/**
 * share-cart.js — Vitae Light (vitaelight.com)
 * Brand color: #EC711D
 */
(function () {
  'use strict';

  if (window.__shareCartInit) return;
  window.__shareCartInit = true;

  var BRAND_COLOR = '#EC711D';
  var BRAND_COLOR_DARK = '#C75A12'; // darker shade for hover
  var SUCCESS_COLOR = '#1d9e75';
  var BORDER_RADIUS = '999px'; // pill-shaped buttons

  function buildPermalink(cart) {
    if (!cart.items || cart.items.length === 0) {
      throw new Error('Cart is empty');
    }
    var params = new URLSearchParams();
    cart.items.forEach(function (item) {
      params.append('items[][id]', String(item.variant_id || item.id));
      params.append('items[][quantity]', String(item.quantity));

      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        params.append('items[][selling_plan]', String(item.selling_plan_allocation.selling_plan.id));
      } else if (item.selling_plan) {
        params.append('items[][selling_plan]', String(item.selling_plan));
      }

      if (item.properties && typeof item.properties === 'object') {
        Object.keys(item.properties).forEach(function (key) {
          if (key.charAt(0) === '_') return;
          var value = item.properties[key];
          if (value === null || value === undefined || value === '') return;
          params.append('items[][properties][' + key + ']', String(value));
        });
      }
    });
    params.append('return_to', '/cart');

    var addUrl = '/cart/add?' + params.toString();
    var clearUrl = '/cart/clear?return_to=' + encodeURIComponent(addUrl);
    return window.location.origin + clearUrl;
  }

  function execCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.width = '1px';
    ta.style.height = '1px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return ok;
  }

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        try {
          var readBack = await navigator.clipboard.readText();
          if (readBack === text) return 'clipboard-api';
        } catch (e) {
          return 'clipboard-api-unverified';
        }
      } catch (e) {
        console.warn('[share-cart] clipboard API failed, falling back:', e);
      }
    }
    if (execCopy(text)) return 'exec-command';
    return null;
  }

  function showCopyModal(url) {
    var existing = document.getElementById('ShareCartModal');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'ShareCartModal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';

    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;color:#000;max-width:480px;width:100%;padding:1.75rem;border-radius:8px;box-shadow:0 10px 40px rgba(0,0,0,.2);font-family:inherit;';

    var heading = document.createElement('h3');
    heading.textContent = 'Share cart link';
    heading.style.cssText = 'margin:0 0 .5rem;font-size:1.125rem;font-weight:500;';

    var desc = document.createElement('p');
    desc.textContent = 'Tap Copy, then paste anywhere — your customer can browse, edit, and pay when ready.';
    desc.style.cssText = 'margin:0 0 1.25rem;font-size:.875rem;opacity:.7;line-height:1.4;';

    var input = document.createElement('input');
    input.type = 'text';
    input.value = url;
    input.readOnly = true;
    input.style.cssText = 'width:100%;padding:.75rem 1rem;border:1px solid #ddd;border-radius:6px;font-size:.8125rem;font-family:monospace;margin-bottom:1.25rem;box-sizing:border-box;color:#555;';

    var actions = document.createElement('div');
    actions.style.cssText = 'display:flex;gap:.5rem;justify-content:flex-end;';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = 'Close';
    closeBtn.style.cssText = 'padding:.625rem 1.5rem;border:1px solid currentColor;background:transparent;color:#000;cursor:pointer;border-radius:' + BORDER_RADIUS + ';font:inherit;font-size:.875rem;transition:opacity .15s;';
    closeBtn.addEventListener('mouseenter', function () { closeBtn.style.opacity = '.6'; });
    closeBtn.addEventListener('mouseleave', function () { closeBtn.style.opacity = '1'; });

    var copyBtn = document.createElement('button');
    copyBtn.type = 'button';
    copyBtn.textContent = 'Copy';
    copyBtn.style.cssText = 'padding:.625rem 1.5rem;background:' + BRAND_COLOR + ';color:#fff;border:1px solid ' + BRAND_COLOR + ';cursor:pointer;border-radius:' + BORDER_RADIUS + ';font:inherit;font-size:.875rem;font-weight:500;min-width:96px;transition:background .15s,border-color .15s;';
    copyBtn.addEventListener('mouseenter', function () {
      if (copyBtn.dataset.state !== 'copied') {
        copyBtn.style.background = BRAND_COLOR_DARK;
        copyBtn.style.borderColor = BRAND_COLOR_DARK;
      }
    });
    copyBtn.addEventListener('mouseleave', function () {
      if (copyBtn.dataset.state !== 'copied') {
        copyBtn.style.background = BRAND_COLOR;
        copyBtn.style.borderColor = BRAND_COLOR;
      }
    });

    copyBtn.addEventListener('click', async function () {
      input.select();
      input.setSelectionRange(0, url.length);
      var method = await copyText(url);
      if (method) {
        copyBtn.dataset.state = 'copied';
        copyBtn.textContent = '✓ Copied';
        copyBtn.style.background = SUCCESS_COLOR;
        copyBtn.style.borderColor = SUCCESS_COLOR;
        setTimeout(function () { overlay.remove(); }, 900);
      } else {
        copyBtn.textContent = 'Press Cmd+C';
      }
    });

    closeBtn.addEventListener('click', function () { overlay.remove(); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.remove();
    });

    actions.appendChild(closeBtn);
    actions.appendChild(copyBtn);
    box.appendChild(heading);
    box.appendChild(desc);
    box.appendChild(input);
    box.appendChild(actions);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    input.focus();
    input.select();
  }

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-share-cart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var labelEl = btn.querySelector('[data-share-cart-label]') || btn;
    var originalLabel = labelEl.textContent;

    try {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('Could not load cart');
      var cart = await res.json();
      var url = buildPermalink(cart);
      console.log('[share-cart] URL:', url);

      showCopyModal(url);

      var method = await copyText(url);
      console.log('[share-cart] Background copy:', method);
    } catch (err) {
      console.error('[share-cart]', err);
      labelEl.textContent = err.message === 'Cart is empty' ? 'Cart is empty' : 'Copy failed';
      setTimeout(function () { labelEl.textContent = originalLabel; }, 2500);
    }
  });
})();